/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ResendLicensingSignUpCodeError = "ALREADYCONFIRMED" | "CODEDELIVERYFAILED" | "INVALIDINPUT" | "UNKNOWNERROR" | "USERNOTFOUND" | "%future added value";
export type ResendLicensingSignUpCodeInput = {
    email?: string | null | undefined;
};
export type resendSignUpCodeMutationVariables = {
    input: ResendLicensingSignUpCodeInput;
};
export type resendSignUpCodeMutationResponse = {
    readonly resendLicensingSignUpCode: {
        readonly wasSuccessful: boolean | null;
        readonly deliveryMedium: string | null;
        readonly errors: ReadonlyArray<{
            readonly errorCode: ResendLicensingSignUpCodeError;
            readonly message: string;
        } | null> | null;
    } | null;
};
export type resendSignUpCodeMutation = {
    readonly response: resendSignUpCodeMutationResponse;
    readonly variables: resendSignUpCodeMutationVariables;
};



/*
mutation resendSignUpCodeMutation(
  $input: ResendLicensingSignUpCodeInput!
) {
  resendLicensingSignUpCode(input: $input) {
    wasSuccessful
    deliveryMedium
    errors {
      errorCode
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ResendLicensingSignUpCode",
            "kind": "LinkedField",
            "name": "resendLicensingSignUpCode",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wasSuccessful",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliveryMedium",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DetailedErrorOfResendLicensingSignUpCode",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "errorCode",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "resendSignUpCodeMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "resendSignUpCodeMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "d42aea4951328cfbee2cf721790f9f3b",
            "id": null,
            "metadata": {},
            "name": "resendSignUpCodeMutation",
            "operationKind": "mutation",
            "text": "mutation resendSignUpCodeMutation(\n  $input: ResendLicensingSignUpCodeInput!\n) {\n  resendLicensingSignUpCode(input: $input) {\n    wasSuccessful\n    deliveryMedium\n    errors {\n      errorCode\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '034d78b9890297ec8464f4a6d321e89c';
export default node;
